import createIcon from '../../createIcon';

/**
 * @component @name Elevator
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgM0g1QzMuOSAzIDMgMy45IDMgNVYxOUMzIDIwLjEgMy45IDIxIDUgMjFIMTlDMjAuMSAyMSAyMSAyMC4xIDIxIDE5VjVDMjEgMy45IDIwLjEgMyAxOSAzWk04LjUgNkM5LjE5IDYgOS43NSA2LjU2IDkuNzUgNy4yNUM5Ljc1IDcuOTQgOS4xOSA4LjUgOC41IDguNUM3LjgxIDguNSA3LjI1IDcuOTQgNy4yNSA3LjI1QzcuMjUgNi41NiA3LjgxIDYgOC41IDZaTTExIDE0SDEwVjE4SDdWMTRINlYxMS41QzYgMTAuNCA2LjkgOS41IDggOS41SDlDMTAuMSA5LjUgMTEgMTAuNCAxMSAxMS41VjE0Wk0xNS41IDE3TDEzIDEzSDE4TDE1LjUgMTdaTTEzIDExTDE1LjUgN0wxOCAxMUgxM1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Elevator = createIcon('Elevator', [
  [
    'path',
    {
      d: 'M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM8.5 6C9.19 6 9.75 6.56 9.75 7.25C9.75 7.94 9.19 8.5 8.5 8.5C7.81 8.5 7.25 7.94 7.25 7.25C7.25 6.56 7.81 6 8.5 6ZM11 14H10V18H7V14H6V11.5C6 10.4 6.9 9.5 8 9.5H9C10.1 9.5 11 10.4 11 11.5V14ZM15.5 17L13 13H18L15.5 17ZM13 11L15.5 7L18 11H13Z',
      key: '1eoqcr',
    },
  ],
]);

export default Elevator;
